export default __webpack_public_path__ + "google-plus-symbol-1.png";